function readEnvFlag(value: string | undefined): boolean {
  return value === "true";
}

function readSampleRate(value: string | undefined, fallback: number): number {
  const parsed = value === undefined ? NaN : Number.parseFloat(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(1, Math.max(0, parsed));
}

export type SentryConfig = {
  enabled: boolean;
  dsn: string | null;
  environment: string;
  release: string | null;
  tracesSampleRate: number;
};

/**
 * Error tracking, not product analytics -- unlike src/analytics/ (PostHog), this is not gated
 * behind the optional-browser-storage consent banner. See docs/OBSERVABILITY.md#privacy.
 */
export function readSentryConfig(): SentryConfig {
  const env = import.meta.env;
  const dsn = env.VITE_SENTRY_DSN?.trim() || null;
  return {
    enabled: readEnvFlag(env.VITE_SENTRY_ENABLED) && Boolean(dsn),
    dsn,
    environment: env.VITE_SENTRY_ENVIRONMENT?.trim() || "development",
    release: env.VITE_SENTRY_RELEASE?.trim() || null,
    tracesSampleRate: readSampleRate(env.VITE_SENTRY_TRACES_SAMPLE_RATE, 0),
  };
}
